// Inline collection keyword search. Toggles an input in the filter bar and
// hides/shows the loaded product cards by matching their text content.
// Re-instantiated on every section re-render, so no global state is needed.

class CollectionSearch extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.collection-search__toggle');
    this.input = this.querySelector('.collection-search__input');
    if (!this.toggle || !this.input) return;

    this.toggle.addEventListener('click', () => this.onToggle());
    this.input.addEventListener('input', () => this.filter());
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.onToggle();
    });
  }

  onToggle() {
    const isHidden = this.input.hasAttribute('hidden');
    if (isHidden) {
      this.input.removeAttribute('hidden');
      this.input.focus();
      this.toggle.setAttribute('aria-expanded', 'true');
    } else {
      this.input.setAttribute('hidden', '');
      this.input.value = '';
      this.toggle.setAttribute('aria-expanded', 'false');
      this.filter();
    }
  }

  filter() {
    const query = this.input.value.toLowerCase().trim();
    const scope = this.closest('.shopify-section') || document;
    const cards = scope.querySelectorAll('li.product-grid__item');

    cards.forEach((card) => {
      const matches = query === '' || card.innerText.toLowerCase().includes(query);
      card.style.display = matches ? '' : 'none';
    });
  }
}

if (!customElements.get('collection-search')) {
  customElements.define('collection-search', CollectionSearch);
}
